export class SearchFileDTO{
    public id!: number;
    public name!: string;
    public customerId!: number;
    public userId!: number;
    public interfaceType!: number;
    public sourceIP!: string;
    public status!: number;
    public moovDefinitionId?:number;
    public moovConfigurationId?:number;
    public moovInstanceId?:number;
    public filepath!: string;
    public receivedAt!: string;
    public isOutputFile!: boolean;
    public purgeAfter!: string;
    public purgedAt!: string;
}